module.exports = __webpack_public_path__ + "static/media/merge-timer-symbol.d45529ae.svg";